import React from 'react';
import { ArticleSection } from './ArticleSection';
import { roiMetrics } from '../../data/articleLists';
export function RoiSection() {
  return <ArticleSection id="roi" title="ROI Metrics That Actually Matter" data-id="element-108" data-mp="u2w6gy266ycg">
      <p data-id="element-109" data-mp="18z3ts78vkfvy">
        Return on investment is only credible if you measure the process before automation starts. Capture
        a baseline for a few weeks, agree the metrics with finance and operations, and then track the same
        numbers after launch.
      </p>
      <div className="glass !mt-6 overflow-x-auto rounded-2xl" role="region" aria-labelledby="roi-caption" tabIndex={0} data-id="element-110" data-mp="bcwpkyghgpk4">
        <table className="w-full min-w-[600px] border-collapse text-left text-[0.95rem]" data-id="element-111" data-mp="q2vnr181g0zl">
          <caption id="roi-caption" className="sr-only" data-id="element-112" data-mp="l9j8hhp916ji">Key ROI metrics for AI workflow automation</caption>
          <thead data-id="element-113" data-mp="3tojf4mpbrce7">
            <tr className="border-b border-line text-sm text-ink" data-id="element-114" data-mp="3orkmk8lb7di4">
              <th scope="col" className="px-5 py-4 font-semibold" data-id="element-115" data-mp="3or1d7g9q5xfp">Metric</th>
              <th scope="col" className="px-5 py-4 font-semibold" data-id="element-116" data-mp="jzsonnie6yjx">What it measures</th>
              <th scope="col" className="px-5 py-4 font-semibold" data-id="element-117" data-mp="o1nkichk0jqb">How to track it</th>
            </tr>
          </thead>
          <tbody data-id="element-118" data-mp="sugogy577o1c">
            {roiMetrics.map(row => <tr key={row.metric} className="border-b border-line align-top last:border-0" data-id="element-119" data-mp="xrz1azmc6nem">
                <th scope="row" className="whitespace-nowrap px-5 py-4 font-semibold text-ink" data-id="element-120" data-mp="1299e25ccjp2">{row.metric}</th>
                <td className="px-5 py-4 text-muted" data-id="element-121" data-mp="531ld35ll2p1">{row.measures}</td>
                <td className="px-5 py-4 text-muted" data-id="element-122" data-mp="55e9jy1y89aj">{row.how}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="rounded-2xl border border-aurora-violet/30 bg-aurora-violet/10 p-5" data-id="element-123" data-mp="f2sfh3q8xfol">
        <p className="!text-sm font-semibold uppercase tracking-wider !text-violet-200" data-id="element-124" data-mp="1limcbtrjtt5e">Simple ROI formula</p>
        <p className="mt-2 font-display !text-xl !leading-8 !text-ink md:!text-2xl" data-id="element-125" data-mp="1qfuxm37zudav">
          ROI = (annual value created − annual total cost) ÷ annual total cost
        </p>
        <p className="mt-2 !text-[0.95rem] !leading-7" data-id="element-126" data-mp="vu75948pvxjt">
          Include build fees, licences, model usage, hosting, monitoring and internal time in total cost.
        </p>
      </div>
    </ArticleSection>;
}